"use client";

import { cn } from "@oreme/ui";
import { cva, type VariantProps } from "class-variance-authority";
import React, { type ReactElement } from "react";

const sectionHeaderVariants = cva(
  "relative flex flex-col gap-0.5 items-center text-center z-20 min-h-10 px-4 mb-8",
  {
    variants: {
      border: {
        true: "border-l-10",
        false: "",
      },
    },
    defaultVariants: {
      border: false,
    },
  },
);

interface HomeSectionHeaderProps
  extends
    React.ComponentProps<"header">,
    VariantProps<typeof sectionHeaderVariants> {
  title: string;
  lead?: string;
  className?: string;
}

function HomeSectionHeader({
  title,
  lead,
  className,
  children,
}: Readonly<HomeSectionHeaderProps>): ReactElement {
  return (
    <header className={cn(sectionHeaderVariants(), className)}>
      <h2 className="text-3xl font-semibold">{title}</h2>
      {lead ? <p className="text-xl opacity-75">{lead}</p> : null}
      {children}
    </header>
  );
}

export { HomeSectionHeader, type HomeSectionHeaderProps };
